// extracted by mini-css-extract-plugin
export default {"Flex":"SsNn9tLNluF62kJNagap","row":"SLlYhgVIF7dh_RkAA4bX","column":"A5300SN7LxffuQBgvDKJ"};